import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-entry-card',
  templateUrl: './entry-card.component.html',
  styleUrls: ['./entry-card.component.scss'],
})
export class EntryCardComponent {
  @Input('cardTitle') cardTitle: string;
  @Input('cardLink') cardLink: string;
  @Input('cardLinkIcon') cardLinkIcon: string = 'chevron_right';
  @Input('iconTitle') iconTitle: string;
  @Input('iconSrc') iconSrc: string;
  @Input('iconHeight') iconHeight: string;
  @Input('iconWidth') iconWidth: string;
  @Input('cardClass') cardClass: string;
  @Input('image1') image1: string;
  @Input('image2') image2: string;
  @Input('image3') image3: string;
  @Input('image4') image4: string;

  constructor(private _router: Router) {}

  public navigate(): void {
    if(this.cardLink.length > 0) this._router.navigateByUrl(this.cardLink);
  }
}
